import {Component, Inject, Input, OnInit} from '@angular/core';
import {DefaultSidebarComponent} from '../default-sidebar/default-sidebar.component';

@Component({
  selector: 'app-touch-expert-sidebar',
  templateUrl: './touch-expert-sidebar.component.html',
  styleUrls: ['../../../education.component.scss', '../../touch.component.scss', './touch-expert-sidebar.component.css']
})
export class TouchExpertSidebarComponent extends DefaultSidebarComponent {
}
